// Single source of truth for which top-level header sections each role can see.
//
// This is a denylist model: a section is visible to everyone EXCEPT the roles
// listed in `hideFor`. Default behaviour (empty list) keeps a section visible to
// all roles, which matches how the app worked before this map existed.
//
// Keys are the section ids used by the header. Roles are matched against the
// Responsible.name carried in the JWT (see helperFunctions.getResponsibleName),
// which is also what the backend uses to gate behaviour. This is the seam to
// grow into a full role-based access model later (e.g. swap `hideFor` denylists
// for per-role `allow` allowlists, or load the map from the backend).
export const NAV_ACCESS = {
  Dashboard: { hideFor: [] },
  Maintenance: { hideFor: [] },
  Workflow: { hideFor: ["MPL"] },
  Purchasing: { hideFor: [] },
  Certificates: { hideFor: ["MPL"] },
  Documents: { hideFor: ["MPL"] },
  Settings: { hideFor: [] },
};

// Returns true when `role` is allowed to see `section`.
// Unknown sections default to visible so adding a new menu item never silently
// hides it before it's added to the map.
export function canSeeSection(section, role) {
  const entry = NAV_ACCESS[section];
  if (!entry) return true;
  return !entry.hideFor.includes(role);
}

// Maps each route path to the nav section that gates it. Paths not listed here
// are not access-controlled (visible to every authenticated role).
export const PATH_TO_SECTION = {
  "/invoices": "Workflow",
  "/emails": "Workflow",
  "/certificates": "Certificates",
  "/certificatename": "Certificates",
  "/documents": "Documents",
  "/settings": "Settings",
};

// Returns true when `role` may load `path`. Unmapped paths are always allowed.
export function canSeePath(path, role) {
  const section = PATH_TO_SECTION[path];
  if (!section) return true;
  return canSeeSection(section, role);
}

// The top-level sections this role can see, in menu order. Used by the Roles
// settings page to show what each role has access to.
export function sectionsForRole(role) {
  return Object.keys(NAV_ACCESS).filter((section) =>
    canSeeSection(section, role),
  );
}
